module.exports = __webpack_public_path__ + "static/media/f273a13b.jpg";